import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { getOptionsQueryParams } from "@app/class/Utilities";
import { IDeviceCommand, IDeviceCommunicationCommand, IDeviceMessage } from "@app/interfaces/IDeviceMessage";
import { IDeviceMessageQueryOptions } from "@app/main/modules/foundation/_models/IDeviceMessageQueryOptions";
import { ICameraRequestUpdateMessage } from "@app/main/modules/foundation/_routes/developerConsole/log-message.model";
import { SignalRService, WebSocketEvents } from "@app/main/modules/foundation/_routes/developerConsole/signalr.service";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})

export class DeviceMessageService {

    deviceMessageCommandUpdateReceived = new Subject<any>()

    constructor(
        private readonly http: HttpClient,
        private readonly signalRService: SignalRService) {
    }

    getDeviceCommunicationCommands(serial: string, isPeripheralCommand: boolean): Observable<IDeviceCommunicationCommand[]> {
        return this.http.get<IDeviceCommunicationCommand[]>(`/api/foundation/devicecommunication/${serial}/types`, { params: { isPeripheralCommand } });
    }

    sendDeviceCommunicationCommands(serial: string, deviceCommand: IDeviceCommand): Observable<IDeviceMessage> {
        return this.http.post<IDeviceMessage>(`/api/foundation/devicecommunication/${serial}/sendcommand`, deviceCommand);
    }

    getAllDeviceMessages(queryOptions: IDeviceMessageQueryOptions): Observable<IDeviceMessage[]> {
        const params = getOptionsQueryParams(queryOptions);
        return this.http.get<IDeviceMessage[]>(`/api/foundation/devicecommunication/devicemessages`, params);
    }

    getDeviceMessageUpdates(serial: string): Observable<ICameraRequestUpdateMessage> {
        this.signalRService.initialise().then(() => {
            this.signalRService.joinDeviceGroup(serial);
            this.signalRService.registerEvents<any>(WebSocketEvents.DeviceMessageCommandUpdate, this.deviceMessageCommandUpdateReceived);
        })
        return this.deviceMessageCommandUpdateReceived;
    }
}
